(function () {
  var boardEl = document.getElementById('wordleBoard');
  if (!boardEl) return;

  var ANSWER = (boardEl.getAttribute('data-answer') || '').toUpperCase().replace(/[^A-Z]/g, '').slice(0, 5);
  var ROWS = 6, COLS = 5;
  var STAGGER = 130;
  var storageKey = 'flamWordle:' + ANSWER;

  function loadState() {
    try {
      var raw = localStorage.getItem(storageKey);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }
  function saveState() {
    try { localStorage.setItem(storageKey, JSON.stringify(state)); } catch (e) {}
  }

  var state = loadState() || { guesses: [], evaluations: [], gameOver: false, won: false };
  var currentRow = state.guesses.length;
  var currentCol = 0;
  var guesses = [];
  for (var i = 0; i < ROWS; i++) guesses.push('');
  var gameOver = !!state.gameOver;

  for (var r = 0; r < ROWS; r++) {
    var rowEl = document.createElement('div');
    rowEl.className = 'wordle-row';
    rowEl.setAttribute('data-row', r);
    for (var c = 0; c < COLS; c++) {
      var tile = document.createElement('div');
      tile.className = 'wordle-tile';
      tile.setAttribute('data-row', r);
      tile.setAttribute('data-col', c);
      rowEl.appendChild(tile);
    }
    boardEl.appendChild(rowEl);
  }

  var messageEl = document.getElementById('wordleMessage');
  var keyboardEl = document.getElementById('wordleKeyboard');
  var KEY_ROWS = ['QWERTYUIOP', 'ASDFGHJKL', 'ZXCVBNM'];

  KEY_ROWS.forEach(function (row, idx) {
    var rowEl = document.createElement('div');
    rowEl.className = 'keyboard-row';
    if (idx === 2) rowEl.appendChild(makeKey('ENTER', true));
    row.split('').forEach(function (letter) { rowEl.appendChild(makeKey(letter)); });
    if (idx === 2) rowEl.appendChild(makeKey('BACK', true));
    keyboardEl.appendChild(rowEl);
  });

  function makeKey(label, wide) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'key' + (wide ? ' key-wide' : '');
    btn.textContent = label === 'BACK' ? '\u232B' : label;
    btn.setAttribute('data-key', label);
    btn.addEventListener('click', function () { handleKey(label); });
    return btn;
  }

  function showStep(id) {
    document.querySelectorAll('.lock-step').forEach(function (el) {
      el.hidden = (el.id !== id);
    });
  }

  var howtoModal = document.getElementById('howtoModal');
  var howtoCloseX = document.getElementById('howtoCloseX');
  var howtoBackdrop = document.getElementById('howtoBackdrop');
  var gotItBtn = document.getElementById('gotItBtn');
  function openHowto() { if (howtoModal) howtoModal.hidden = false; }
  function closeHowto() { if (howtoModal) howtoModal.hidden = true; }

  var playBtn = document.getElementById('playBtn');
  if (playBtn) playBtn.addEventListener('click', openHowto);
  if (howtoCloseX) howtoCloseX.addEventListener('click', closeHowto);
  if (howtoBackdrop) howtoBackdrop.addEventListener('click', closeHowto);
  if (gotItBtn) gotItBtn.addEventListener('click', function () { closeHowto(); showStep('stepGame'); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && howtoModal && !howtoModal.hidden) closeHowto();
  });

  function handleKey(key) {
    if (gameOver) return;
    if (key === 'ENTER') { submitGuess(); return; }
    if (key === 'BACK') { removeLetter(); return; }
    if (/^[A-Z]$/.test(key)) addLetter(key);
  }

  function addLetter(letter) {
    if (currentCol >= COLS) return;
    guesses[currentRow] += letter;
    var tile = boardEl.querySelector('[data-row="' + currentRow + '"][data-col="' + currentCol + '"]');
    tile.textContent = letter;
    tile.classList.add('filled');
    currentCol++;
  }

  function removeLetter() {
    if (currentCol <= 0) return;
    currentCol--;
    guesses[currentRow] = guesses[currentRow].slice(0, -1);
    var tile = boardEl.querySelector('[data-row="' + currentRow + '"][data-col="' + currentCol + '"]');
    tile.textContent = '';
    tile.classList.remove('filled');
  }

  function evaluateGuess(guess) {
    var answerLetters = ANSWER.split('');
    var guessLetters = guess.split('');
    var result = [];
    var used = [];
    for (var i = 0; i < COLS; i++) { result.push('absent'); used.push(false); }
    for (var i = 0; i < COLS; i++) {
      if (guessLetters[i] === answerLetters[i]) { result[i] = 'correct'; used[i] = true; }
    }
    for (var i = 0; i < COLS; i++) {
      if (result[i] === 'correct') continue;
      for (var j = 0; j < COLS; j++) {
        if (!used[j] && guessLetters[i] === answerLetters[j]) { result[i] = 'present'; used[j] = true; break; }
      }
    }
    return result;
  }

  function submitGuess() {
    var guess = guesses[currentRow];
    if (guess.length !== COLS) { showMessage('Not enough letters'); shakeRow(currentRow); return; }
    if (!ANSWER || ANSWER.length !== 5) { showMessage('This week\u2019s word isn\u2019t set up yet'); return; }

    var result = evaluateGuess(guess);
    var thisRow = currentRow;
    gameOver = true;

    for (var i = 0; i < COLS; i++) {
      (function (i) {
        setTimeout(function () {
          var tile = boardEl.querySelector('[data-row="' + thisRow + '"][data-col="' + i + '"]');
          tile.classList.add('reveal', result[i]);
          updateKey(guess[i], result[i]);
          if (i === COLS - 1) finishReveal(thisRow, guess, result);
        }, i * STAGGER);
      })(i);
    }
  }

  function finishReveal(row, guess, result) {
    state.guesses[row] = guess;
    state.evaluations[row] = result;

    if (guess === ANSWER) {
      state.gameOver = true;
      state.won = true;
      saveState();
      showWin();
      return;
    }

    currentRow++;
    currentCol = 0;

    if (currentRow >= ROWS) {
      state.gameOver = true;
      state.won = false;
      saveState();
      gameOver = true;
      showMessage('Out of guesses \u2014 the answer was ' + ANSWER + '. Come back next week for a new one.');
      return;
    }

    gameOver = false;
    saveState();
  }

  function updateKey(letter, resultState) {
    var rank = { absent: 0, present: 1, correct: 2 };
    var keyBtn = keyboardEl.querySelector('[data-key="' + letter + '"]');
    if (!keyBtn) return;
    var existing = keyBtn.getAttribute('data-state');
    if (!existing || rank[resultState] > rank[existing]) {
      keyBtn.setAttribute('data-state', resultState);
      keyBtn.classList.remove('absent', 'present', 'correct');
      keyBtn.classList.add(resultState);
    }
  }

  function shakeRow(r) {
    var rowEl = boardEl.querySelector('.wordle-row[data-row="' + r + '"]');
    rowEl.classList.add('shake');
    setTimeout(function () { rowEl.classList.remove('shake'); }, 400);
  }

  function showMessage(msg) { messageEl.textContent = msg; }

  function showWin() {
    var toast = document.getElementById('winToast');
    if (toast) toast.hidden = false;
    var panel = document.getElementById('unlockPanel');
    if (panel) panel.hidden = false;

    var realField = document.getElementById('realPasswordField');
    var realForm = document.getElementById('realUnlockForm');
    if (realField) realField.value = ANSWER;
    if (realForm) {
      setTimeout(function () { realForm.submit(); }, 1400);
    }
  }

  document.addEventListener('keydown', function (e) {
    if (gameOver) return;
    var k = e.key.toUpperCase();
    if (k === 'ENTER') handleKey('ENTER');
    else if (k === 'BACKSPACE') handleKey('BACK');
    else if (/^[A-Z]$/.test(k) && k.length === 1) handleKey(k);
  });

  var hintToggle = document.getElementById('hintToggle');
  var hintText = document.getElementById('hintText');
  if (hintToggle) {
    hintToggle.addEventListener('click', function () {
      var showing = !hintText.hidden;
      hintText.hidden = showing;
      hintToggle.textContent = showing ? 'Need a hint?' : 'Hide hint';
    });
  }

  (function restore() {
    for (var row = 0; row < state.guesses.length; row++) {
      var guess = state.guesses[row];
      var evalRow = state.evaluations[row];
      if (!guess) continue;
      for (var c = 0; c < guess.length; c++) {
        var tile = boardEl.querySelector('[data-row="' + row + '"][data-col="' + c + '"]');
        tile.textContent = guess[c];
        tile.classList.add('filled');
        if (evalRow && evalRow[c]) {
          tile.classList.add(evalRow[c]);
          updateKey(guess[c], evalRow[c]);
        }
      }
    }
    if (state.gameOver) {
      if (state.won) {
        showWin();
      } else {
        showMessage('Out of guesses \u2014 the answer was ' + ANSWER + '. Come back next week for a new one.');
      }
    }
  })();

  var songs = (window.__lockPageSongs || []).filter(function (s) { return s && s.url; }).slice(0, 3);
  var playerWrap = document.querySelector('.music-player');
  if (!songs.length) {
    if (playerWrap) playerWrap.style.display = 'none';
    return;
  }

  var audioA = document.getElementById('audioA');
  var audioB = document.getElementById('audioB');
  var playToggle = document.getElementById('playToggle');
  var playIcon = document.getElementById('playIcon');
  var pauseIcon = document.getElementById('pauseIcon');
  var titleEl = document.getElementById('nowPlayingTitle');
  var progressFill = document.getElementById('progressFill');

  var players = [audioA, audioB];
  var activeIndex = 0;
  var trackIndex = 0;
  var CROSSFADE = 9;
  var isPlaying = false;
  var crossfading = false;
  var rafId = null;

  function loadTrack(playerEl, songIdx) {
    playerEl.src = songs[songIdx].url;
    playerEl.volume = 0;
    playerEl.currentTime = 0;
  }

  function setTitle() {
    titleEl.textContent = songs[trackIndex].title || ('Track ' + (trackIndex + 1));
  }

  function startPlayback() {
    trackIndex = 0;
    activeIndex = 0;
    loadTrack(players[activeIndex], trackIndex);
    players[activeIndex].volume = 1;
    players[activeIndex].play().catch(function () {});
    setTitle();
    monitor();
  }

  function updateProgress() {
    var active = players[activeIndex];
    if (active && active.duration && progressFill) {
      var pct = Math.min(100, (active.currentTime / active.duration) * 100);
      progressFill.style.width = pct + '%';
    }
  }

  function monitor() {
    cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(function tick() {
      if (!isPlaying) return;
      var active = players[activeIndex];
      updateProgress();
      if (active && active.duration && !crossfading) {
        var remaining = active.duration - active.currentTime;
        if (remaining <= CROSSFADE && songs.length > 1) beginCrossfade();
      }
      rafId = requestAnimationFrame(tick);
    });
  }

  function beginCrossfade() {
    crossfading = true;
    var fromIdx = activeIndex;
    var toIdx = (activeIndex + 1) % players.length;
    var nextTrack = (trackIndex + 1) % songs.length;

    loadTrack(players[toIdx], nextTrack);
    players[toIdx].play().catch(function () {});

    var from = players[fromIdx];
    var to = players[toIdx];
    var remaining = from.duration - from.currentTime;
    var duration = remaining > 0 ? Math.min(CROSSFADE, remaining) : CROSSFADE;
    var start = null;

    function step(ts) {
      if (!start) start = ts;
      var elapsed = (ts - start) / 1000;
      var p = Math.min(elapsed / duration, 1);
      from.volume = Math.max(0, 1 - p);
      to.volume = Math.min(1, p);
      if (p < 1 && isPlaying) {
        requestAnimationFrame(step);
      } else {
        from.pause();
        from.volume = 0;
        activeIndex = toIdx;
        trackIndex = nextTrack;
        setTitle();
        crossfading = false;
        if (isPlaying) monitor();
      }
    }
    requestAnimationFrame(step);
  }

  playToggle.addEventListener('click', function () {
    if (!isPlaying) {
      isPlaying = true;
      playIcon.style.display = 'none';
      pauseIcon.style.display = '';
      if (!players[activeIndex].src) {
        startPlayback();
      } else {
        players[activeIndex].play().catch(function () {});
        monitor();
      }
    } else {
      isPlaying = false;
      playIcon.style.display = '';
      pauseIcon.style.display = 'none';
      players.forEach(function (p) { p.pause(); });
      cancelAnimationFrame(rafId);
    }
  });
})();
